var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}

/**
 * An utilitary function that given a set of selected SDMX datasources,
 * artefact types, categories, agencies and versions, will return the list
 * of request options (see getRequestArgs) to be applied in order to retrieve
 * the all sets of artefacts matching this selection.
 *
 * @memberOf SDMXJS
 * @name getArtefactsListsRequestsArgs
 * @api public
 * @tag function
 * @param {Object}
 * @return {Array}
 *
 * @example
 * const selection = {
 *   spaces: { ... },
 *   agencies: { ... },
 *   categories: { ... },
 *   types: [],
 *   versions: []
 * };
 *
 * const requestsArgs = SDMXJS.getArtefactsListsRequestsArgs(selection);
 *
 * R.forEach(
 *   ({ url, header, params }) => {
 *     axios.get(url, { headers, params }).then( ... );
 *   },
 *   requestsArgs
 * )
 */
import * as R from 'ramda';
import { getArtefactsListRequestArgs } from './getArtefactsListRequestArgs';
import { ALL } from './constants/types';
import { cartesian } from './utils';
var agencyCodeParser = function agencyCodeParser(agency) {
  return R.startsWith('SDMX', R.prop('id', agency)) ? R.prop('code', agency) : R.prop('id', agency);
};
var getArtefactsListsRequestsArgs = function getArtefactsListsRequestsArgs(_ref) {
  var agencies = _ref.agencies,
    categories = _ref.categories,
    spaces = _ref.spaces,
    locale = _ref.locale,
    types = _ref.types,
    versions = _ref.versions,
    rest = _objectWithoutProperties(_ref, ['agencies', 'categories', 'spaces', 'locale', 'types', 'versions']);
  var nothingIsAll = R.when(R.isEmpty, R.always([ALL]));
  var nothingIsNothing = R.when(R.isEmpty, R.always([null]));
  var selection = R.evolve({
    agencyIds: R.pipe(R.values, R.map(agencyCodeParser)),
    types: nothingIsAll,
    categories: R.values,
    spaces: R.pipe(R.values, R.map(function (sp) {
      return _extends({}, sp, {
        url: sp.endpoint
      });
    }))
  }, {
    spaces: spaces,
    agencyIds: agencies,
    categories: categories,
    types: types,
    versions: versions
  });
  return R.pipe(R.map(function (space) {
    var categories = R.pipe(R.filter(R.pipe(R.prop('spaceId'), R.anyPass([R.equals(space.id), R.isNil]))), nothingIsNothing)(selection.categories);
    return R.pipe(R.map(R.prepend(space)))(cartesian([categories, selection.types, nothingIsAll(selection.agencyIds), selection.versions]));
  }), R.unnest, R.map(function (_ref2) {
    var datasource = _ref2[0],
      category = _ref2[1],
      type = _ref2[2],
      agencyId = _ref2[3],
      version = _ref2[4];
    return getArtefactsListRequestArgs(_extends({
      agencyIds: selection.agencyIds,
      datasource: datasource,
      category: category,
      type: type,
      agencyId: agencyId,
      version: version,
      locale: locale
    }, rest));
  }))(selection.spaces);
};
export { getArtefactsListsRequestsArgs };